export const toOptionalNumber = (value: unknown): number | undefined => {
  if (value == null) return undefined; // NOSONAR
  const n = typeof value === "string" ? Number(value.trim()) : Number(value);

  return Number.isFinite(n) ? n : undefined;
};

export const toOptionalString = (value: unknown): string | undefined => {
  if (value == null) return undefined; // NOSONAR

  if (typeof value === "number") {
    return Number.isFinite(value) ? String(value) : undefined;
  }

  const str = typeof value === "string" ? value.trim() : "";
  return str || undefined;
};

type ProNormalizationOptions = {
  trimExactLength?: number;
  trimToLength?: number;
};

export const normalizeProValue = (
  value: unknown,
  options: ProNormalizationOptions = {},
): number | undefined => {
  if (value == null || value === "") return undefined; // NOSONAR

  const text = String(value).trim();
  if (!text) return undefined;

  const { trimExactLength = 12, trimToLength = 11 } = options;
  const normalized =
    /^\d+$/.test(text) &&
    text.length === trimExactLength &&
    trimToLength < trimExactLength
      ? text.slice(0, trimToLength)
      : text;

  const numeric = Number(normalized);
  return Number.isFinite(numeric) ? numeric : undefined;
};

/**
 * Checks if an exception is partially cleared (has clearing details with clearedPieces > 0 AND openPieces > 0)
 */
export const isPartiallyCleared = (clearedInstructionDetails?: { cleared?: boolean; details?: Array<{ openPieces?: number; clearedPieces?: number }> } | null): boolean => {
  if (!clearedInstructionDetails?.details?.length) return false;
  if (clearedInstructionDetails.cleared === true) return false;
  
  // Check if any clearing detail has BOTH clearedPieces > 0 AND openPieces > 0
  return clearedInstructionDetails.details.some((detail) => (detail.clearedPieces ?? 0) > 0 && (detail.openPieces ?? 0) > 0);
};